import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button, Card, Form, Input, Container, Row, Col, FormGroup, Label } from "reactstrap";
import ReactNotificationAlert from "react-notification-alert";
import BackToLogin from "components/BackToLogin";

import { useFormik } from "formik";

import NotificationAlert from "react-notification-alert";

import { staticData } from "managers/staticDataManager";
import { forgotPasswordValidationSchema, initialForgotPasswordModal } from "../validations";
import { handleForgotPassword } from "../callApi";
import { EMAIL_RULE } from "config";

const ForgotPassword = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("register-page");
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
  });

  const notificationAlertRef = React.useRef(null);
  const state = useSelector((state) => state);
  const [isBusy, setIsBusy] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const validationSchema = forgotPasswordValidationSchema(state);

  const formik = useFormik({
    initialValues: initialForgotPasswordModal,
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (data) => {
      let model = prepareModel(data);
      handleForgotPassword(state, model, setIsBusy, setIsSuccess, notificationAlertRef);
    },
  });

  const prepareModel = (rawData) => {
    const isEmail = EMAIL_RULE.test(rawData.usefulData);

    if(isEmail) {
        return {
            email: rawData.usefulData
        };
    };

    return {
        userName: rawData.usefulData
    };
}

  return (
    <React.Fragment>
      <div className="react-notification-alert-container">
        <ReactNotificationAlert ref={notificationAlertRef} />
      </div>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="6">
            <Card className="card-register ml-auto mr-auto">
              <Form onSubmit={formik.handleSubmit} hidden={isSuccess}>
                  <FormGroup>
                      <Label for="formCheckEmail" style={{fontWeight: 'bold'}}>{staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_Question")}</Label>
                      <Input id="formUsefulData" name="usefulData" type="text" placeholder={staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_formUsefulData")}
                          disabled={isBusy} onChange={formik.handleChange} value={formik.values.usefulData}/>
                      <div className="text-danger" style={{fontWeight: 'bold'}}>
                          {formik.errors.usefulData ? formik.errors.usefulData : null}
                      </div>
                  </FormGroup>                
                  <Button block className="btn-round" color="danger" type="submit" disabled={isBusy}>
                    {staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_BtnConfirm")}
                  </Button>
              </Form>
              <div hidden={!isSuccess}>
                <div className="card-body">
                    <div><b>
                      <div dangerouslySetInnerHTML={{ __html: staticData.loadTerms(state, "VW_ISSUER_ForgotPassword_DoneMessage") }} />
                    </b></div>
                </div>
              </div>
              <BackToLogin />
            </Card>
          </Col>
        </Row>
      </Container>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
    </React.Fragment>
  );
}

export default ForgotPassword;
